import {ref, watch} from '@vue/composition-api'
import store from '../../../store'
import {ChatService} from '../../services'
import {chatUseCase} from '../../usecases'

const useRoom = async (ids) => {
    const isEcommercePlatform = store.getters.isEcommercePlatform    
    const roomId = ref(null)
    const doc = isEcommercePlatform ?  
        await ChatService.getRoomsByShops(`${ids[0]}_${ids[1]}`).get():
        await ChatService.getRoomsByCampaigns(`${ids[0]}_${ids[1]}`).get()
    if(!doc.empty) {
        roomId.value = doc.docs[0].id
    } else {
        const room = isEcommercePlatform ? 
            await chatUseCase.createShopRoom(ids): 
            await chatUseCase.createRoom(ids)

        if(room.id) {
            roomId.value = room.id
        }
    }

    return roomId
}

export default useRoom





